var map = {
	"./page-config/analytics-mappings/view-mappings.tsx": 75965,
	"./page-config/client-list-base-ccy.tsx": 40224,
	"./page-config/client-list.tsx": 48777,
	"./page-config/documents-storage.tsx": 71424,
	"./page-config/documents-upload.tsx": 85840,
	"./page-config/excel-addin.tsx": 17579,
	"./page-config/excel-addin/exposure-reports.tsx": 33097,
	"./page-config/excel-addin/intro.tsx": 51729,
	"./page-config/menu-mappings/view.tsx": 54938,
	"./page-config/portfolio.tsx": 47254,
	"./page-config/portfolio/allocations.tsx": 5473,
	"./page-config/portfolio/allocations/group.tsx": 94838,
	"./page-config/portfolio/cashflows/future.tsx": 4300,
	"./page-config/portfolio/cashflows/historic.tsx": 27922,
	"./page-config/portfolio/documents.tsx": 80009,
	"./page-config/portfolio/holdings.tsx": 95266,
	"./page-config/portfolio/movers/total-pnl.tsx": 39601,
	"./page-config/portfolio/networth.tsx": 10678,
	"./page-config/portfolio/performance-without-ms.tsx": 41360,
	"./page-config/portfolio/performance.tsx": 97063,
	"./page-config/portfolio/performance/create-strategy/query-based.tsx": 91743,
	"./page-config/portfolio/performance/create-strategy/rule-based.tsx": 27201,
	"./page-config/portfolio/performance/create-strategy/template-based.tsx": 20733,
	"./page-config/portfolio/performance/view-strategies-without-create.tsx": 38588,
	"./page-config/portfolio/performance/view-strategies.tsx": 50652,
	"./page-config/portfolio/portfolio-status.tsx": 27346,
	"./page-config/portfolio/transactions.tsx": 41024,
	"./page-config/reports/fee-report.tsx": 53419,
	"./page-config/reports/fee-report/view-reports.tsx": 97552,
	"./page-config/reports/partner-documents.tsx": 23528,
	"./page-config/reports/tableau-to-ppt.tsx": 28662,
	"./page-config/reports/tableau-to-ppt/view-reports.tsx": 16867,
	"./page-config/review-all/allocations.tsx": 29740,
	"./page-config/review-all/allocations/group.tsx": 89110,
	"./page-config/review-all/cashflows/future.tsx": 77129,
	"./page-config/review-all/cashflows/historic.tsx": 62579,
	"./page-config/review-all/documents.tsx": 36611,
	"./page-config/review-all/holdings.tsx": 98842,
	"./page-config/review-all/movers/total-pnl.tsx": 74552,
	"./page-config/review-all/networth.tsx": 66368,
	"./page-config/review-all/performance-without-ms.tsx": 60357,
	"./page-config/review-all/performance.tsx": 22705,
	"./page-config/review-all/performance/create-strategy/query-based.tsx": 77762,
	"./page-config/review-all/performance/create-strategy/rule-based.tsx": 92006,
	"./page-config/review-all/performance/create-strategy/template-based.tsx": 24269,
	"./page-config/review-all/performance/view-strategies-without-create.tsx": 6099,
	"./page-config/review-all/performance/view-strategies.tsx": 44454,
	"./page-config/review-all/portfolio-status.tsx": 80683,
	"./page-config/review-all/transactions.tsx": 79962,
	"./page-config/settings/user-preferences.tsx": 28623,
	"./page-config/superadmin-user-selection.tsx": 72702,
	"./page-config/tableau-analytics.tsx": 42956,
	"./page-config/tableau-analytics/customer-workbooks.tsx": 4091,
	"./page-config/upload-documents/data-management.tsx": 55388,
	"./page-config/upload-documents/documents-storage.tsx": 26020,
	"./page-config/upload-documents/statement-processing.tsx": 13251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74312;